let elements = {
  blockCheck: true,
  fontFamily: 'Linotype',
  fontSize: '45px',
  mainImage: {
    imagePath: 'games/page010_game2/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  withoutCheck: false,
  columns: 4,
  audio: {
    negative: 'games/page010_game2/audio/false.mp3',
    positive: 'games/page010_game2/audio/true.mp3',
    click: 'games/page010_game2/audio/click.mp3',
  },
  imageHighlight: true,
  curtain: 'transparent',
  curtainImage: {
    src: 'games/page010_game2/img/des.webp',
  },
  width: 346,
  bcgImg: 'games/page010_game2/img/desBcg.webp',
  height: 272,
  // goodAudio: 'games/page010_game2/audio/z2c2.mp3',
  colors: ['#f7a82b', '#ffff00', '#ed6c9e', '#ff0000', '#00a8ec', '#00b034'],
  pick: 6,
  fields: [
    {
      id: 0,
      image: {
        src: 'games/page010_game2/img/00.png',
      },
      audioSrc: 'games/page010_game2/audio/00.mp3',
      pair: {
        id: 0,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'Dusty',
        audioSrc: 'games/page010_game2/audio/00.mp3',
      },
    },
    {
      id: 1,
      image: {
        src: 'games/page010_game2/img/01.png',
      },
      audioSrc: 'games/page010_game2/audio/01.mp3',
      pair: {
        id: 1,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'hello',
        audioSrc: 'games/page010_game2/audio/01.mp3',
      },
    },
    {
      id: 2,
      image: {
        src: 'games/page010_game2/img/02.png',
      },
      audioSrc: 'games/page010_game2/audio/02.mp3',
      pair: {
        id: 2,

        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'bye-bye',
        audioSrc: 'games/page010_game2/audio/02.mp3',
      },
    },
    {
      id: 3,
      image: {
        src: 'games/page010_game2/img/03.png',
      },
      audioSrc: 'games/page010_game2/audio/03.mp3',
      pair: {
        id: 3,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'Tom',
        audioSrc: 'games/page010_game2/audio/03.mp3',
      },
    },
    {
      id: 4,
      image: {
        src: 'games/page010_game2/img/04.png',
      },
      audioSrc: 'games/page010_game2/audio/04.mp3',
      pair: {
        id: 4,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'Lisa',
        audioSrc: 'games/page010_game2/audio/04.mp3',
      },
    },
    {
      id: 5,
      image: {
        src: 'games/page010_game2/img/05.png',
      },
      audioSrc: 'games/page010_game2/audio/05.mp3',
      pair: {
        id: 5,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'rabbit',
        audioSrc: 'games/page010_game2/audio/05.mp3',
      },
    },
    {
      id: 6,
      audioSrc: 'games/page010_game2/audio/06.mp3',
      image: {
        src: 'games/page010_game2/img/06.png',
      },
      pair: {
        id: 6,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'bear',
        audioSrc: 'games/page010_game2/audio/06.mp3',
      },
    },
    {
      id: 7,
      audioSrc: 'games/page010_game2/audio/07.mp3',
      image: {
        src: 'games/page010_game2/img/07.png',
      },
      pair: {
        id: 7,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'mole',
        audioSrc: 'games/page010_game2/audio/07.mp3',
      },
    },
    {
      id: 8,
      audioSrc: 'games/page010_game2/audio/08.mp3',
      image: {
        src: 'games/page010_game2/img/08.png',
      },
      pair: {
        id: 8,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'red',
        audioSrc: 'games/page010_game2/audio/08.mp3',
      },
    },
    {
      id: 9,
      audioSrc: 'games/page010_game2/audio/09.mp3',
      image: {
        src: 'games/page010_game2/img/09.png',
      },
      pair: {
        id: 9,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'yellow',
        audioSrc: 'games/page010_game2/audio/09.mp3',
      },
    },
    {
      audioSrc: 'games/page010_game2/audio/10.mp3',
      id: 10,
      image: {
        src: 'games/page010_game2/img/10.png',
      },
      pair: {
        id: 10,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'blue',
        audioSrc: 'games/page010_game2/audio/10.mp3',
      },
    },
    {
      audioSrc: 'games/page010_game2/audio/11.mp3',
      id: 11,
      image: {
        src: 'games/page010_game2/img/11.png',
      },
      pair: {
        id: 11,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'green',
        audioSrc: 'games/page010_game2/audio/11.mp3',
      },
    },
    {
      audioSrc: 'games/page010_game2/audio/12.mp3',
      id: 12,
      image: {
        src: 'games/page010_game2/img/12.png',
      },
      pair: {
        id: 12,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'purple',
        audioSrc: 'games/page010_game2/audio/12.mp3',
      },
    },
    {
      audioSrc: 'games/page010_game2/audio/13.mp3',
      id: 13,
      image: {
        src: 'games/page010_game2/img/13.png',
      },
      pair: {
        id: 13,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'pink',
        audioSrc: 'games/page010_game2/audio/13.mp3',
      },
    },
    {
      audioSrc: 'games/page010_game2/audio/14.mp3',
      id: 14,
      image: {
        src: 'games/page010_game2/img/14.png',
      },
      pair: {
        id: 14,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'orange',
        audioSrc: 'games/page010_game2/audio/14.mp3',
      },
    },
  ],
  // mbAudioItemData: [
  // ],
};
export default elements;
